import { render } from "./EditContribuable.vue?vue&type=template&id=7961bc2c"
import script from "./EditContribuable.vue?vue&type=script&lang=js"
export * from "./EditContribuable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__